function ResetButton() {
  const handleReset = () => {
    if (window.confirm('Are you sure you want to reset your age and progress?')) {
      localStorage.removeItem('userAge');
      localStorage.removeItem('playlistProgress');
      window.location.reload();
    }
  };
  return (
    <button className="reset-icon-button" onClick={handleReset} aria-label="Reset Progress and Age" title="Reset your age and progress">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18" r="18" fill="url(#resetGradient)" />
        <rect x="12" y="15" width="12" height="11" rx="2" fill="none" stroke="#fff" strokeWidth="2.2" />
        <rect x="13" y="11" width="10" height="4" rx="2" fill="#fff" />
        <rect x="15" y="19" width="2" height="5" rx="1" fill="#fff" />
        <rect x="19" y="19" width="2" height="5" rx="1" fill="#fff" />
        <rect x="17" y="19" width="2" height="5" rx="1" fill="#fff" />
        <defs>
          <linearGradient id="resetGradient" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
            <stop stopColor="#1976d2" />
            <stop offset="1" stopColor="#42a5f5" />
          </linearGradient>
        </defs>
      </svg>
    </button>
  );
}
import React, { useState, useEffect } from 'react';
import YouTubePlayer from './YouTubePlayer';
import AgeHeaderAnimation from './AgeHeaderAnimation';
import './App.css';

// Use the user's provided playlist ID
const agePlaylists = {
  default: 'PLyGtFLMO29eZGl4ZfiMYADUSOnVmpz5zP',
};

const App = () => {
  const [age, setAge] = useState(() => localStorage.getItem('userAge') || '');
  const [showPlayer, setShowPlayer] = useState(!!localStorage.getItem('userAge'));

  useEffect(() => {
    if (showPlayer && age) {
      localStorage.setItem('userAge', age);
    }
  }, [showPlayer, age]);

  const handleAgeSubmit = (e) => {
    e.preventDefault();
    if (age) {
      setShowPlayer(true);
      localStorage.setItem('userAge', age);
    }
  };

  const playlistId = agePlaylists[age] || agePlaylists.default;

  // Progress bar state
  const [currentIndex, setCurrentIndex] = useState(() => {
    const saved = localStorage.getItem('playlistProgress');
    return saved ? parseInt(saved, 10) : 0;
  });
  const [totalVideos, setTotalVideos] = useState(0);

  // Save progress to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('playlistProgress', currentIndex);
  }, [currentIndex]);

  return (
    <div className="App">
      {/* Age-based header animation */}
      <AgeHeaderAnimation age={parseInt(age, 10)} puzzleIndex={currentIndex} />
      {!showPlayer ? (
        <form onSubmit={handleAgeSubmit} className="age-form">
          <label htmlFor="age" className="age-label">Please select your age:</label>
          <select
            id="age"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            required
            className="age-select"
          >
            <option value="">Select age</option>
            {[...Array(96)].map((_, i) => (
              <option key={i + 5} value={i + 5}>{i + 5}</option>
            ))}
          </select>
          <button type="submit" className="age-button">Continue</button>
        </form>
      ) : (
        <>
          <YouTubePlayer
            playlistId={playlistId}
            startIndex={currentIndex}
            onVideoChange={setCurrentIndex}
            onPlaylistLength={setTotalVideos}
          />
          <div className="progress-bar-container">
            <div className="progress-bar">
              <div
                className="progress-bar-fill"
                style={{ width: totalVideos > 0 ? `${((currentIndex + 1) / totalVideos) * 100}%` : '0%' }}
              />
            </div>
            <div className="progress-bar-label">
              {totalVideos > 0 ? `Progress: ${currentIndex + 1} / ${totalVideos}` : 'Loading playlist...'}
            </div>
          </div>
        </>
      )}
      <ResetButton />
    </div>
  );
};

export default App;
